import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, Checkbox, Divider, FormControlLabel, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import { FormikProps } from 'formik';
import React, { useState } from 'react'

interface Props {
    formik: FormikProps<any>;
}

function OwnerInformation({ formik }: Props) {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    return (
        <Box className='p-xl-5 p-md-3 p-1 mt-2 mt-md-0'>
            <Typography variant='h6' className='fw-bold' gutterBottom>Personal Information</Typography>
            <Grid container spacing={1.5} className='form-text-field'>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>First Name</Typography>
                    <TextField
                        name='firstName'
                        fullWidth
                        placeholder='Enter first name'
                        value={formik.values.firstName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                        helperText={
                            formik.touched.firstName
                                ? (formik.errors.firstName as string)
                                : ""
                        }
                    />

                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>Last Name</Typography>
                    <TextField
                        name='lastName'
                        fullWidth
                        placeholder='Enter last name'
                        value={formik.values.lastName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                        helperText={
                            formik.touched.lastName
                                ? (formik.errors.lastName as string)
                                : ""
                        }
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>Designation</Typography>
                    <TextField
                        name='designation'
                        fullWidth
                        placeholder='Enter designation'
                        value={formik.values.designation}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.designation &&
                            Boolean(formik.errors.designation)
                        }
                        helperText={
                            formik.touched.designation
                                ? (formik.errors.designation as string)
                                : ""
                        }
                    />

                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>Email</Typography>
                    <TextField
                        name='email'
                        fullWidth
                        placeholder='Enter email'
                        type='email'
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={
                            formik.touched.email
                                ? (formik.errors.email as string)
                                : ""
                        }
                    />

                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>Mobile Number</Typography>
                    <TextField
                        name='mobileNumber'
                        fullWidth
                        type='tel'
                        placeholder='Enter mobile number'
                        value={formik.values.mobileNumber}
                        onChange={(e) => {
                            const numbersOnly = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 10);

                            formik.setFieldValue("mobileNumber", numbersOnly);
                        }}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.mobileNumber &&
                            Boolean(formik.errors.mobileNumber)
                        }
                        helperText={
                            formik.touched.mobileNumber
                                ? (formik.errors.mobileNumber as string)
                                : ""
                        }
                    />

                </Grid>
                {/* <Grid size={{ xs: 12, md: 4 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>Alternate Mobile Number</Typography>
                    <TextField
                        name='alternateMobileNumber'
                        fullWidth
                        type='tel'
                        placeholder='Enter alternate number'
                        value={formik.values.alternateMobileNumber}
                        onChange={(e) => {
                            const numbersOnly = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 10);

                            formik.setFieldValue("alternateMobileNumber", numbersOnly);
                        }}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.alternateMobileNumber &&
                            Boolean(formik.errors.alternateMobileNumber)
                        }
                        helperText={
                            formik.touched.alternateMobileNumber
                                ? (formik.errors.alternateMobileNumber as string)
                                : ""
                        }
                    />

                </Grid> */}
            </Grid>

            <Divider className='my-4' />
            <Typography variant='h6' className='fw-bold' gutterBottom>Login Credentials</Typography>
                <Grid container spacing={1.5} className="mb-3 form-text-field">
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography
                            className="fw-bold input-label"
                            variant="body2"
                            gutterBottom
                        >
                            Password
                        </Typography>

                        <TextField
                            name="password"
                            fullWidth
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                                formik.touched.password &&
                                Boolean(formik.errors.password)
                            }
                            helperText={
                                formik.touched.password
                                    ? (formik.errors.password as string)
                                    : ""
                            }
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() =>
                                                    setShowPassword((prev) => !prev)
                                                }
                                                edge="end"
                                                aria-label={
                                                    showPassword
                                                        ? "Hide password"
                                                        : "Show password"
                                                }
                                            >
                                                {showPassword
                                                    ? <VisibilityOff />
                                                    : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                },
                            }}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography
                            className="fw-bold input-label"
                            variant="body2"
                            gutterBottom
                        >
                            Confirm Password
                        </Typography>

                        <TextField
                            name="confirmPassword"
                            fullWidth
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Enter confirm password"
                            value={formik.values.confirmPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                                formik.touched.confirmPassword &&
                                Boolean(formik.errors.confirmPassword)
                            }
                            helperText={
                                formik.touched.confirmPassword
                                    ? (formik.errors.confirmPassword as string)
                                    : ""
                            }
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() =>
                                                    setShowConfirmPassword((prev) => !prev)
                                                }
                                                edge="end"
                                                aria-label={
                                                    showConfirmPassword
                                                        ? "Hide confirm password"
                                                        : "Show confirm password"
                                                }
                                            >
                                                {showConfirmPassword
                                                    ? <VisibilityOff />
                                                    : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                },
                            }}
                        />
                    </Grid>
                </Grid>
        </Box>
    )
}

export default OwnerInformation
{/* <Typography variant='h6' className='fw-bold' gutterBottom>Security</Typography>
<FormControlLabel
className='d-block'
    control={
        <Checkbox
            checked={true}
            // onChange={(e) => setChecked(e.target.checked)}
            sx={{
                color: "var(--primary-color)",
                "&.Mui-checked": {
                    color: "var(--primary-color)",
                },
            }}
        />
    }
    label="Send Welcome Email"
/>
<FormControlLabel
className='d-block'
    control={
        <Checkbox
            checked={true}
            // onChange={(e) => setChecked(e.target.checked)}
            sx={{
                color: "var(--primary-color)",
                "&.Mui-checked": {
                    color: "var(--primary-color)",
                },
            }}
        />
    }
    label="Force Password Change on First Login"
/>
<FormControlLabel
className='d-block'
    control={
        <Checkbox
            checked={true}
            // onChange={(e) => setChecked(e.target.checked)}
            sx={{
                color: "var(--primary-color)",
                "&.Mui-checked": {
                    color: "var(--primary-color)",
                },
            }}
        />
    }
    label="Enable Two-Factor Authantication (2FA)"
/> */}
